"use client";
import { useContext } from 'react';
import { Context, getRollbarFromContext } from './Provider.js';

function useRollbar() {
  var context = useContext(Context);
  return getRollbarFromContext(context);
}

export { useRollbar };
//# sourceMappingURL=useRollbar.js.map
